<template>
    <BasicDropdown
        :options="langs"
        v-model="selectedLang"
        class="language-selector"
        :alignement="alignement"
        :neededPlaceholder="false"
        name="language-selector"
        @update:modelValue="updateLanguage"
    >
        <template #selected>
            <img :src="selectedLang.img" alt="" class="flag-wrapper" />
            {{ selectedLang.name }}
        </template>
        <template #options="{ name, img }">
            <img :src="img" alt="" class="flag-wrapper" />
            {{ name }}
        </template>
    </BasicDropdown>
</template>

<script>
import BasicDropdown from "@/components/basic/BasicDropdown.vue"

export default {
    name: "LanguageSelector",
    components: {
        BasicDropdown,
    },
    props: {
        alignement: {
            type: String,
            default: "auto",
        },
    },
    data() {
        return {
            langs: [
                {
                    name: "France",
                    value: "fr",
                    img: "./img/flags/fr.svg",
                },
                {
                    name: "United Kingdom",
                    value: "en",
                    img: "./img/flags/gb.svg",
                },
                {
                    name: "Suisse (Français)",
                    value: "ch-fr",
                    img: "./img/flags/ch.svg",
                },
                {
                    name: "Schweiz (Deutsch)",
                    value: "ch-de",
                    img: "./img/flags/ch.svg",
                },
                {
                    name: "Danmark",
                    value: "dk",
                    img: "./img/flags/dk.svg",
                },
                {
                    name: "Suomi",
                    value: "fi",
                    img: "./img/flags/fi.svg",
                },
                {
                    name: "Deutschland",
                    value: "de",
                    img: "./img/flags/de.svg",
                },
                {
                    name: "Belgique (Français)",
                    value: "be-fr",
                    img: "./img/flags/be.svg",
                },
                {
                    name: "België (Vlaams)",
                    value: "be-fl",
                    img: "./img/flags/be.svg",
                },
                {
                    name: "Luxembourg (Français)",
                    value: "lu-fr",
                    img: "./img/flags/lu.svg",
                },
                {
                    name: "Luxemburg (Deutsch)",
                    value: "lu-de",
                    img: "./img/flags/lu.svg",
                },
                {
                    name: "Norge",
                    value: "no",
                    img: "./img/flags/no.svg",
                },
                {
                    name: "Nederland",
                    value: "nl",
                    img: "./img/flags/nl.svg",
                },
                {
                    name: "Sverige",
                    value: "se",
                    img: "./img/flags/se.svg",
                },
                {
                    name: "España",
                    value: "es",
                    img: "./img/flags/es.svg",
                },
                {
                    name: "Italia",
                    value: "it",
                    img: "./img/flags/it.svg",
                },
            ],
            selectedLang: {
                name: "",
                value: "",
            },
        }
    },
    methods: {
        //  Change route (current route with new lang parameter)
        changeLanguage(langCode) {
            this.$store.commit("account/setLanguage", langCode)
            window.location.href =
                window.location.origin + `/${langCode}/` + this.$route.href
        },
        updateLanguage(value) {
            this.selectedLang = value
            this.changeLanguage(this.selectedLang.value)
        },
        // Set selected language in dropdown
        setSelectedLanguage() {
            const language = this.$store.getters["account/getLanguage"] ?? "fr"
            this.selectedLang = this.langs.find(
                (item) => item.value === language,
            )
        },
    },
    created() {
        this.setSelectedLanguage()
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.language-selector {
    width: max-content;
    height: min-content;
}

.flag-wrapper {
    width: 20px;
    aspect-ratio: square;
}
</style>
